import React from "react";
import { connect } from "react-redux";
import { WelcomeBanner } from "../../components/ui";

const subtitles = [
  "Sua plataforma de transporte.",
  "É bom te ver de novo",
  "Vamos acompanhar seus projetos em andamento?",
];

const helperTexts = [
  "Acesse as funcionalidades pelo menu lateral para iniciar suas atividades.",
];

const images = [1, 2, 3, 4].map((n) => `${process.env.PUBLIC_URL}/images/background/welcome-${n}.png`);

const WelcomePage = ({ user }) => {
  const userName =
    user?.usu_nome ||
    user?.name ||
    user?.empresa?.emp_nome_fantasia ||
    user?.empresa?.emp_razao_social ||
    "Usuário";

  const empresaNome =
    user?.empresa?.emp_nome_fantasia ||
    user?.empresa?.emp_razao_social ||
    "";

  const badgeText = empresaNome ? (
    <>
      Você está logado na empresa: <strong>{empresaNome}</strong>
    </>
  ) : null;

  return (
    <WelcomeBanner
      userName={userName}
      badgeText={badgeText}
      subtitles={subtitles}
      helperTexts={helperTexts}
      images={images}
      logoSrc={`${process.env.PUBLIC_URL}/images/logo-white.png`}
    />
  );
};

const mapStateToProps = ({ auth: { user } }) => ({ user });

export default connect(mapStateToProps)(WelcomePage);
